import { Box, SimpleGrid, useStyleConfig } from '@chakra-ui/react';
import ProgressBar from './ProgressBar';
import { getPFSComponents } from './utils';
import { getQuestion } from '../../handlers/utils';

const PFSWrapper = (
  {
    props,
    groupedQuestions,
    secOrIndIndex,
    isMultipart = false,
    columns = 1,
  },
) => {
  const [pfsNav, qGroup, step] = getPFSComponents(
    props,
    groupedQuestions,
    secOrIndIndex,
    isMultipart,
  );
  const section = props.stateProps.sectionData.sectionName;
  const variant = 'wrapper';
  const styles = {};
  styles.pfs = useStyleConfig('PFS', { variant });
  return (
    <Box sx={{ ...styles.pfs }}>
      <Box className="pfsWrapper">
        {section !== 'interview-you' && section !== 'interview-questions' && section !== 'new-aptitude' && section !== 'grow-goals' && (
          <ProgressBar isMultipart={isMultipart} stepIndex={step} groupedQuestions={groupedQuestions}
                       section={section} />
        )}
        <Box className="alignment">
          <SimpleGrid
            spacing={['0 8px', '0 8px', '12px 20px']}
            columns={[0, 0, columns]}
            rows={[columns, columns, 0]}
            className="grid"
          >
            {qGroup.map((qObj, key) => getQuestion(props, qObj, key, secOrIndIndex, isMultipart))}
          </SimpleGrid>
        </Box>
        <Box>
          {/* this is a specific reference.  Move presence of "backButton" to question data? */}
          {props.stateProps.sectionData.sectionName !== 'start' && pfsNav}
        </Box>
      </Box>
    </Box>
  );
};

export default PFSWrapper;
